import React from 'react';
import { generateContent } from '../../helpers/plunger';
import { serviceAPI } from '../../InterfaceAPI/serviceAPI';
// TODO: Handle success/error messages.  Commented out to avoid linter errors
// import { stringfyServerErrors } from '../../helpers/util';
import { Redirect } from 'react-router-dom';
import ModalEnabled from '../extend/ModalEnabled';
import SkipWeekModal from '../menuSelection/SkipWeekModal';

const now = new Date().getTime();
const week = 604800 * 1000; // Number of seconds in a week.
const fourWeeksFromNow = now + week * 4;

class ListItem extends ModalEnabled {
  state = {
    redirect_to: false
  };

  render() {
    const { columns, menu } = this.props;

    if (this.state.redirect_to) return <Redirect to={this.state.redirect_to} />;

    return (
      <tr className="table__tr">
        {this.renderColumns(menu, columns)}
        {this.renderSelectMenuColumn(menu)}
        {this.renderSkipColumn(menu)}
        <SkipWeekModal
          isOpen={this.isOpen('skip-week')}
          closeModal={this.closeModal}
          skipWeek={this.handleSkipWeek}
        />
      </tr>
    );
  }

  renderColumns = (data, columns) => {
    return columns.map((specs, i) => this.renderColumn(data, specs, i));
  };

  renderColumn = (data, specs, i) => {
    const classes = `p table__td ${specs.class || ''}`;

    // if there's no prop, return empty
    if (!specs.link && !specs.raw && !data)
      return <td key={i} className={classes} />;

    let content = generateContent(data, specs);

    return (
      <td key={i} className={classes}>
        {content}
      </td>
    );
  };

  handleSkipWeek = (reason = '') => {
    const { menu } = this.props;
    serviceAPI
      .skipService(menu.id, reason)
      .then(res => {
        this.closeModal();
      })
      .catch(err => {
        console.error(err);
      });
  };

  handleUnskipWeek = menu => {
    // Will uncomment on next PR where API route added
    serviceAPI
      .unSkipService(menu.id)
      .then(res => {
        console.log(res);
        this.setState({ redirect_to: '/' });
      })
      .catch(err => {
        console.error(err);
      });
  };

  renderSelectMenuColumn(menu) {
    // Client Dashboard only
    if (!this.props.currentRoute.includes('admin')) {
      // If menu not skipped
      if (!menu.skipped) {
        let time = new Date(menu.start_time).getTime();
        // For services before 4 weeks from now (including past services).
        if (time < fourWeeksFromNow) {
          if (menu.service_type === 'custom_weekly') {
            // Custom weekly
            return (
              <td key={menu.id}>
                <a href={`/service/${menu.id}`} className="a--blue">
                  View Service
                </a>
              </td>
            );
          } else if (!menu.menu_selections.length && time > now) {
            // only display "select menu" link if service not in past
            return (
              <td key={menu.id}>
                <a
                  href={`/menu-selection/${menu.id}`}
                  className="a--blue"
                  data-test={`${menu.service_type}-select-menu`}
                >
                  Select Menu
                </a>
              </td>
            );
          } else {
            return (
              <td key={menu.id}>
                <a href={`/service/${menu.id}`} className="a--blue">
                  View Service
                </a>
              </td>
            );
          }
        } else {
          // empty cell beyond 4 weeks
          return <td key={menu.id} />;
        }
      } else {
        // empty cell if skipped
        return <td key={menu.id} />;
      }
    }
  }

  renderSkipLink() {
    return (
      <td>
        <span className="a--blue" onClick={() => this.openModal('skip-week')}>
          Skip
        </span>
      </td>
    );
  }

  renderUnskipLink(menu) {
    return (
      <td>
        <span className="a--blue" onClick={() => this.handleUnskipWeek(menu)}>
          Unskip
        </span>
      </td>
    );
  }

  renderSkipColumn(menu) {
    // If service is upcoming
    if (!this.props.isPast) {
      // no menu selections made and service has not been skipped
      if (!this.props.menu.menu_selections.length && !this.props.menu.skipped) {
        return this.renderSkipLink();
      }

      //  no menu selections made and service has been skipped
      if (!this.props.menu.menu_selections.length && this.props.menu.skipped) {
        return this.renderUnskipLink(menu);
      }

      // menu selections made and service has not been skipped
      if (this.props.menu.menu_selections.length && !this.props.menu.skipped) {
        return <td />;
      }

      // menu selections made and service has been skipped
      if (this.props.menu.menu_selections.length && this.props.menu.skipped) {
        return this.renderUnskipLink(menu);
      }
    } else {
      if (this.props.menu.skipped) {
        return <td class="p tabled_td"><span>SKIPPED</span></td>
      }
    }
  }
}

export default ListItem;



// WEBPACK FOOTER //
// ./src/components/shared/ListItemClient.js